/**
 * Keys used in all microapps and container app
 */
export const ApplicationMetaData = {
         logglyToken: 'f9777ecd-8743-4acc-90d3-ca8c1c9c2bfa',
         logglyTagName: 'ew-v2-logger',
         SENTRY_DSN:
           'https://b260a60f34d042a78562000ae5609fec@o443521.ingest.sentry.io/6367343',
         logRocketKey: 'bvndxu/easywebinar'//'mikbl4/easywebinar'
       };
